//多站总览
const multiStationEn = {
  mulStaLang: {
    多站总览: 'Multi site Overview',
    创建电站: 'Create a power station',
    站点总数: 'Total number of sites',
    个: '',
    在线: 'Online',
    离线: 'Offline',
    待运维: 'waiting O&M',
    装机功率: 'Installed power',
    装机容量: 'Installed capacity',
    今日充电量: 'Charging data/Today',
    较昨日下降: 'Compared to yesterday',
    较昨日增长: 'Compared to yesterday',
    月充电: 'Monthly',
    累计充电: 'Accumulated',
    今日放电量: 'Discharge data/Today',
    月放电: 'Monthly',
    累计放电: 'Accumulated',
    今日收益: 'Income for the day',
    元: '',
    万元: 'K',
    本月收益: 'Monthly income',
    总收益: 'Total revenue',
    收益统计: 'Revenue statistics',
    充放电统计: 'Electricity statistics',
    近7日: 'Last 7 days',
    近31日: 'Last 31 days',
    近12月: 'Last 12 months',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    收益排名: 'Revenue ranking',
    '收益/万元': 'Income/K',
    本月: 'This month',
    本年: 'This year',
    收益: 'Income',

    站点列表: 'Site List',
    通讯状态: 'Communication Status',
    全部: 'All',
    电站筛选: 'Power station screening',
    待运维电站: 'Power station to be operated and maintained',
    请输入电站名称: 'Please enter the name of the power station',
    查询: 'Query',
    重置: 'Reset',
    导出: 'Export',
    电站名称: 'Name of power station',
    待运维处理: 'Waiting O&M handling',
    在线状态: 'Online status',
    总充电量: 'Total charging capacity',
    总放电量: 'Total discharge capacity',
    '昨日收益(元)': 'Yesterday＇s earnings(CNY)',
    '总收益(万元)': 'Total revenue(K)',
    综合效率: 'Overall efficiency',
    放电达成率: 'Discharge completion rate',
    序号: 'Serial Number',
    暂无数据: 'No data available',
    复制成功: 'Copy success'
  }
}

export default multiStationEn
